const EVENTS_KEY = 'client-data';

const get = () => {
  try {
    const jsonValue = localStorage.getItem(EVENTS_KEY);
    return jsonValue != null ? JSON.parse(jsonValue) : null;
  } catch (error) {
    console.error('Error retrieving my events:', error);
    return null;
  }
};

const set = (events) => {
  try {
    const jsonValue = JSON.stringify(events);
    localStorage.setItem(EVENTS_KEY, jsonValue);
  } catch (error) {
    console.error('Error saving my events:', error);
  }
};

export default {
  get,
  set,
};
